import LabelDescricaoService from "@/services/LabelDescricaoService";

export const labelDescricao = {
  namespaced: true,
  state: {
    labelDescricao: {},
  },
  actions: {
    getLabelDescricao({ commit }, payload) {
      return LabelDescricaoService.GetLabelDescricao(payload).then(
        (labelDescricao) => {
          return Promise.resolve(labelDescricao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postLabelDescricao({ commit }, payload) {
      return LabelDescricaoService.PostLabelDescricao(payload).then(
        (labelDescricao) => {
          return Promise.resolve(labelDescricao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putLabelDescricao({ commit }, payload) {
      return LabelDescricaoService.PutLabelDescricao(payload).then(
        (labelDescricao) => {
          return Promise.resolve(labelDescricao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteLabelDescricao({ commit }, payload) {
      return LabelDescricaoService.DeleteLabelDescricao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getLabelDescricaoOData({ commit }, payload) {
      return LabelDescricaoService.GetLabelDescricaoOData(payload).then(
        (labelDescricao) => {
          return Promise.resolve(labelDescricao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default labelDescricao;
